import { BASE_URL, REACT_DEV } from "../config.js";

// const PUBLIC_FOLDER = process.env.PUBLIC_URL;

const urlPrefix = `${BASE_URL}/assets/image/`;

const menuBlue = REACT_DEV
  ? require("./assets/image/menu-blue.png")
  : `${urlPrefix}menu-blue.png`;
const menuGray = REACT_DEV
  ? require("./assets/image/menu-gray.png")
  : `${urlPrefix}menu-gray.png`;
const backBlue = REACT_DEV
  ? require("./assets/image/back-blue.png")
  : `${urlPrefix}back-blue.png`;
const backGray = REACT_DEV
  ? require("./assets/image/back-gray.png")
  : `${urlPrefix}back-gray.png`;
const addSongBlue = REACT_DEV
  ? require("./assets/image/add-song-blue.png")
  : `${urlPrefix}add-song-blue.png`;
const addSongGray = REACT_DEV
  ? require("./assets/image/add-song-gray.png")
  : `${urlPrefix}add-song-gray.png`;
const playerBlue = REACT_DEV
  ? require("./assets/image/player-blue.png")
  : `${urlPrefix}player-blue.png`;
const playerGray = REACT_DEV
  ? require("./assets/image/player-gray.png")
  : `${urlPrefix}player-gray.png`;
const playlistBlue = REACT_DEV
  ? require("./assets/image/playlist-blue.png")
  : `${urlPrefix}playlist-blue.png`;
const playlistGray = REACT_DEV
  ? require("./assets/image/playlist-gray.png")
  : `${urlPrefix}playlist-gray.png`;
const profileBlue = REACT_DEV
  ? require("./assets/image/profile-blue.png")
  : `${urlPrefix}profile-blue.png`;
const profileGray = REACT_DEV
  ? require("./assets/image/profile-gray.png")
  : `${urlPrefix}profile-gray.png`;
const serverBlue = REACT_DEV
  ? require("./assets/image/server-blue.png")
  : `${urlPrefix}server-blue.png`;
const serverGray = REACT_DEV
  ? require("./assets/image/server-gray.png")
  : `${urlPrefix}server-gray.png`;
const settingBlue = REACT_DEV
  ? require("./assets/image/setting-blue.png")
  : `${urlPrefix}setting-blue.png`;
const settingGray = REACT_DEV
  ? require("./assets/image/setting-gray.png")
  : `${urlPrefix}setting-gray.png`;
const statsBlue = REACT_DEV
  ? require("./assets/image/stats-blue.png")
  : `${urlPrefix}stats-blue.png`;
const statsGray = REACT_DEV
  ? require("./assets/image/stats-gray.png")
  : `${urlPrefix}stats-gray.png`;
const importGray = REACT_DEV
  ? require("./assets/image/import-gray.png")
  : `${urlPrefix}import-gray.png`;
const importBlue = REACT_DEV
  ? require("./assets/image/import-blue.png")
  : `${urlPrefix}import-blue.png`;
const infoGray = REACT_DEV
  ? require("./assets/image/info-gray.png")
  : `${urlPrefix}info-gray.png`;
const infoBlue = REACT_DEV
  ? require("./assets/image/info-blue.png")
  : `${urlPrefix}info-blue.png`;
const programmerGray = REACT_DEV
  ? require("./assets/image/hacker.png")
  : `${urlPrefix}programmer-gray.png`;

const navPlaylistAdd = REACT_DEV
  ? require("./assets/image/nav-playlist-add.png")
  : `${urlPrefix}nav-playlist-add.png`;
const navPlaylistYour = REACT_DEV
  ? require("./assets/image/nav-playlist-your.png")
  : `${urlPrefix}nav-playlist-your.png`;
const navPlaylistSpotify = REACT_DEV
  ? require("./assets/image/nav-playlist-spotify.png")
  : `${urlPrefix}nav-playlist-spotify.png`;
const navPlaylistYoutube = REACT_DEV
  ? require("./assets/image/nav-playlist-yt.png")
  : `${urlPrefix}nav-playlist-yt.png`;

const navServerJoin = REACT_DEV
  ? require("./assets/image/nav-server-join.png")
  : `${urlPrefix}nav-server-join.png`;
const navServerHistory = REACT_DEV
  ? require("./assets/image/nav-server-history.png")
  : `${urlPrefix}nav-server-history.png`;

// navigation arts
const defaultVideoArt = REACT_DEV
  ? require("./assets/image/default-video-art.png")
  : `${urlPrefix}default-video-art.png`;
const playerArt = REACT_DEV
  ? require("./assets/image/player-art.png")
  : `${urlPrefix}player-art.png`;
const importArt = REACT_DEV
  ? require("./assets/image/import-art.png")
  : `${urlPrefix}import-art.png`;
const serverArt = REACT_DEV
  ? require("./assets/image/server-art.png")
  : `${urlPrefix}server-art.png`;
const settingArt = REACT_DEV
  ? require("./assets/image/setting-art.png")
  : `${urlPrefix}setting-art.png`;
const playlistArt = REACT_DEV
  ? require("./assets/image/playlist-art.png")
  : `${urlPrefix}playlist-art.png`;
const queueArt = REACT_DEV
  ? require("./assets/image/queue-art.png")
  : `${urlPrefix}queue-art.png`;
const queueListArt = REACT_DEV
  ? require("./assets/image/queue-list-art.png")
  : `${urlPrefix}queue-list-art.png`;

const miniPlay = REACT_DEV
  ? require("./assets/image/mini-play.png")
  : `${urlPrefix}mini-play.png`;
const miniPause = REACT_DEV
  ? require("./assets/image/mini-pause.png")
  : `${urlPrefix}mini-pause.png`;
const miniNext = REACT_DEV
  ? require("./assets/image/mini-next.png")
  : `${urlPrefix}mini-next.png`;
const miniExpand = REACT_DEV
  ? require("./assets/image/mini-expand.png")
  : `${urlPrefix}mini-expand.png`;

const songPaused = REACT_DEV
  ? require("./assets/image/song-paused.png")
  : `${urlPrefix}song-paused.png`;

const notFound = REACT_DEV
  ? require("./assets/image/404.png")
  : `${urlPrefix}404.png`;

const youtubeLogo = REACT_DEV
  ? require("./assets/image/youtube-logo.png")
  : `${urlPrefix}youtube-logo.png`;
const spotifyLogo = REACT_DEV
  ? require("./assets/image/spotify-logo.png")
  : `${urlPrefix}spotify-logo.png`;
const googleLogo = REACT_DEV
  ? require("./assets/image/google-logo.png")
  : `${urlPrefix}google-logo.png`;
const miniWindowLogo = REACT_DEV
  ? require("./assets/image/mini-window-logo.png")
  : `${urlPrefix}mini-window-logo.png`;
const playlistLogo = REACT_DEV
  ? require("./assets/image/playlist-logo.png")
  : `${urlPrefix}playlist-logo.png`;
const roomLogo = REACT_DEV
  ? require("./assets/image/room-logo.png")
  : `${urlPrefix}room-logo.png`;

const logo = REACT_DEV
  ? require("./assets/image/logo.png")
  : `${urlPrefix}logo.png`;
const logoText = REACT_DEV
  ? require("./assets/image/logo-text.png")
  : `${urlPrefix}logo-text.png`;

const avatar = REACT_DEV
  ? require("./assets/image/avatar.png")
  : `${urlPrefix}avatar.png`;

const authBackground = REACT_DEV
  ? require("./assets/image/auth-background.png")
  : `${urlPrefix}auth-background.png`;

const ankitImg = REACT_DEV
  ? require("./assets/image/ankit1.png")
  : `${urlPrefix}ankit1.png`;

const windowMinimize = REACT_DEV
  ? require("./assets/image/window-minimize.png")
  : `${urlPrefix}window-minimize.png`;
const windowMaximize = REACT_DEV
  ? require("./assets/image/window-maximize.png")
  : `${urlPrefix}window-maximize.png`;
const windowClose = REACT_DEV
  ? require("./assets/image/window-close.png")
  : `${urlPrefix}window-close.png`;
const windowIdle = REACT_DEV
  ? require("./assets/image/window-window.png")
  : `${urlPrefix}window-window.png`;

export {
  menuBlue,
  menuGray,
  backBlue,
  backGray,
  addSongBlue,
  addSongGray,
  playerBlue,
  playerGray,
  playlistBlue,
  playlistGray,
  profileBlue,
  profileGray,
  serverBlue,
  serverGray,
  settingBlue,
  settingGray,
  programmerGray,
  statsBlue,
  statsGray,
  importGray,
  importBlue,
  infoGray,
  infoBlue,
  navPlaylistAdd,
  navPlaylistYour,
  navPlaylistSpotify,
  navPlaylistYoutube,
  navServerJoin,
  navServerHistory,
  defaultVideoArt,
  importArt,
  serverArt,
  settingArt,
  playlistArt,
  playerArt,
  queueArt,
  queueListArt,
  miniPlay,
  miniPause,
  miniNext,
  miniExpand,
  songPaused,
  notFound,
  youtubeLogo,
  spotifyLogo,
  miniWindowLogo,
  playlistLogo,
  googleLogo,
  roomLogo,
  logo,
  logoText,
  avatar,
  authBackground,
  ankitImg,
  windowMinimize,
  windowMaximize,
  windowClose,
  windowIdle,
};
